// @flow
import React, { Component } from 'react';
import moment from 'moment';
import { Range } from 'rc-slider';
import { Wrapper, handleStyle, trackStyle, railStyle } from './style';
import 'rc-slider/assets/index.css';

const today = moment().format('YYYY');
const year = parseInt(today, 0) + 2;

type State = {
  firstYear: number,
  lastYear: number
};

type Props = {
  firstYear: number,
  lastYear: number,
  onChange: any => void,
  updateInPlace: boolean,
  width?: string
};

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this,
      args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    //$FlowFixMe
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

class YearSelect extends Component<Props, State> {
  state = {
    firstYear: 0,
    lastYear: 0
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    return {
      ...state,
      firstYear: props.firstYear,
      lastYear: props.lastYear
    };
  }

  debouncedChange = debounce(function() {
    this.props.onChange({
      min: this.state.firstYear,
      max: this.state.lastYear
    });
  }, 250);

  handleChange = (value: [number, number], force: boolean = false) => {
    const { updateInPlace } = this.props;
    const firstYear = value[0] >= 1900 || force ? value[0] : 1900;
    const lastYear = value[1] <= year || force ? value[1] : year;

    this.setState({ firstYear: parseInt(firstYear, 0), lastYear });

    updateInPlace && this.debouncedChange();
  };

  handleKeyPress = (e: any): void => {
    const { firstYear, lastYear } = this.state;
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      if (firstYear <= lastYear) this.debouncedChange();
    }
  };

  handleMinValue = (event: { target: { value: number } }) => {
    const {
      target: { value }
    } = event;
    const { lastYear } = this.state;

    this.handleChange([parseInt(value, 0), lastYear], true);
  };

  handleMaxValue = (event: { target: { value: number } }) => {
    const {
      target: { value }
    } = event;
    const { firstYear } = this.state;

    this.handleChange([firstYear, parseInt(value, 0)], true);
  };

  handleBlurMin = (event: { target: { value: number } }) => {
    const {
      target: { value }
    } = event;
    const { lastYear } = this.state;

    this.handleChange([
      parseInt(value < 1900 ? 1900 : value > lastYear ? lastYear : value, 0),
      lastYear
    ]);
  };

  handleBlurMax = (event: { target: { value: number } }) => {
    const {
      target: { value }
    } = event;
    const { firstYear } = this.state;

    this.handleChange([
      firstYear,
      parseInt(value >= year ? year : value < firstYear ? firstYear : value, 0)
    ]);
  };

  render() {
    const { firstYear, lastYear } = this.state;
    const { width = '350px' } = this.props;

    return (
      <Wrapper width={width}>
        <div className="row-years">
          <div className="input-zone">
            <input
              onChange={this.handleMinValue}
              onKeyPress={this.handleKeyPress}
              onBlur={this.handleBlurMin}
              value={firstYear || ''}
              maxLength={4}
              type="text"
            />
            <input
              onChange={this.handleMaxValue}
              onKeyPress={this.handleKeyPress}
              onBlur={this.handleBlurMax}
              value={lastYear || ''}
              maxLength={4}
              type="text"
            />
          </div>

          <div>
            <br />
            <div className="range-container">
              <Range
                trackStyle={[trackStyle]}
                handleStyle={[handleStyle, handleStyle]}
                railStyle={railStyle}
                onChange={this.handleChange}
                onAfterChange={() => this.debouncedChange()}
                value={[firstYear || this.props.firstYear, lastYear || year]}
                allowCross={false}
                tabIndex={[0, 0]}
                min={1900 - 15}
                max={year + 15}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default YearSelect;



// WEBPACK FOOTER //
// ./src/components/YearSelect/index.js